// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_bf-b";
export var colorBlue = "_bf-8";
export var colorDot = "_bf-0";
export var colorDotLarge = "_bf-2";
export var colorDotSmall = "_bf-1";
export var colorGreen = "_bf-7";
export var colorGrey = "_bf-3";
export var colorOrange = "_bf-5";
export var colorPink = "_bf-a";
export var colorPurple = "_bf-9";
export var colorRed = "_bf-4";
export var colorYellow = "_bf-6";